"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatchAssertionError = exports.FormatAssertionError = exports.ParseError = exports.RIDUtilsError = void 0;
class RIDUtilsError extends Error {
    constructor({ message = 'An error occured with the @sharefile/rid-utils library', type = 'GenericError', parentError }) {
        super(message);
        this.type = type;
        this.parentError = parentError;
    }
}
exports.RIDUtilsError = RIDUtilsError;
class ParseError extends RIDUtilsError {
    constructor({ message = 'Error occurred trying to parse a RID.', parentError }) {
        super({ message, parentError, type: ParseError.name });
    }
}
exports.ParseError = ParseError;
class FormatAssertionError extends RIDUtilsError {
    constructor({ message = 'Error occurred trying to assert a given RID follows a given format.', parentError }) {
        super({ message, parentError, type: FormatAssertionError.name });
    }
}
exports.FormatAssertionError = FormatAssertionError;
class MatchAssertionError extends RIDUtilsError {
    constructor({ message = 'Error occurred trying to assert the given RIDs have matching root IDs.', parentError }) {
        super({ message, parentError, type: MatchAssertionError.name });
    }
}
exports.MatchAssertionError = MatchAssertionError;
//# sourceMappingURL=errors.js.map